import { USERS_LIST_REQUEST } from "../actions/constants";

export const listUsers = (payload: any = { limit: 0 }) => {
  return {
    type: USERS_LIST_REQUEST,
    payload,
  };
};
